/** Shown when API is offline — mirrors backend default seed data. */
export const LOCAL_CONSUMPTION_BY_COUNTRY = [
  { countryCode: 'FR', countryName: 'France', value: 18420, unit: 'requests', percent: 31.2 },
  { countryCode: 'TN', countryName: 'Tunisia', value: 9620, unit: 'requests', percent: 16.3 },
  { countryCode: 'IT', countryName: 'Italy', value: 7480, unit: 'requests', percent: 12.7 },
  { countryCode: 'ES', countryName: 'Spain', value: 6310, unit: 'requests', percent: 10.7 },
  { countryCode: 'TR', countryName: 'Turkey', value: 5240, unit: 'requests', percent: 8.9 },
  { countryCode: 'MA', countryName: 'Morocco', value: 4180, unit: 'requests', percent: 7.1 },
  { countryCode: 'EG', countryName: 'Egypt', value: 3520, unit: 'requests', percent: 6.0 },
  { countryCode: 'PT', countryName: 'Portugal', value: 2890, unit: 'requests', percent: 4.9 },
  { countryCode: 'GR', countryName: 'Greece', value: 2140, unit: 'requests', percent: 3.6 },
  { countryCode: 'DE', countryName: 'Germany', value: 1980, unit: 'requests', percent: 3.4 },
];
